<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="900" scrollable>
			<v-card>
				<v-card-title class="text-h6">
					<span>Detail Penjualan Langsung</span>
					<span class="pl-2 font-weight-bold">{{ detailSR.sr_code }}</span>
				</v-card-title>
				<v-card-text class="black--text">
					<v-row class="mb-3">
						<v-col cols="6" md="3">
							<div class="body-2 oppacity-75">ID Mitra</div>
							<div class="subtitle-2">{{ detailSR.sr_buyer_network_mid }}</div>
							<div class="body-2 pt-3 oppacity-75">Nama Mitra</div>
							<div class="subtitle-2">{{ detailSR.sr_buyer_name }}</div>
							<div class="body-2 pt-3 oppacity-75">Catatan Pembayaran</div>
							<div>
								<div class="subtitle-2" v-if="detailSR.sr_payment_note">
									<span v-html="detailSR.sr_payment_note"></span>
								</div>
								<div class="subtitle-2" v-else>-</div>
							</div>
						</v-col>
						<v-col cols="6" md="3">
							<div class="body-2 oppacity-75">Nomor Handphone</div>
							<div class="subtitle-2">{{ detailSR.sr_buyer_mobilephone }}</div>
							<div class="body-2 pt-3 oppacity-75">Tanggal Transaksi</div>
							<div class="subtitle-2">{{ detailSR.sr_datetime | tanggaljam }}</div>
							<div class="body-2 pt-3 oppacity-75">Catatan</div>
							<div class="subtitle-2">{{ detailSR.sr_note ? detailSR.sr_note : '-' }}</div>
						</v-col>
						<v-col cols="6" md="6">
							<div class="body-2 oppacity-75">Email</div>
							<div class="subtitle-2">{{ detailSR.sr_buyer_email }}</div>
							<div class="body-2 oppacity-75">Alamat</div>
							<div class="subtitle-2">{{ detailSR.sr_buyer_address }}</div>
						</v-col>
					</v-row>
					<v-list color="deep-purple lighten-5" class="pa-1 mb-3" rounded>
						<v-list-item dense class="px-1 justify-center">
							<div class="font-weight-bold text-uppercase primary--text">Detail Produk</div>
						</v-list-item>
					</v-list>
					<v-card class="mb-5 elevation-0">
						<v-data-table :headers="headersProduct" :items="detailSR.sr_detail" hide-default-footer>
							<template v-slot:item.sr_detail_quantity="{ item }">
								<div>{{ item.sr_detail_quantity | toNumber }}</div>
							</template>
							<template v-slot:item.sr_detail_product_price="{ item }">
								<div>{{ item.sr_detail_product_price | toNumber }}</div>
							</template>
							<template v-slot:item.total_price="{ item }">
								<div v-if="item.sr_detail_product_price <= 0">0</div>
								<div v-else>{{ item.sr_detail_product_price * item.sr_detail_quantity  | toNumber }}</div>
							</template>
							<template v-slot:footer>
								<v-row class="mt-n3">
									<v-col offset="8">Subtotal</v-col>
									<v-col class="font-weight-bold text-right">{{ grandTotal | toRupiah }}</v-col>
								</v-row>
								<v-row class="mt-n3" v-if="discountTotal > 0">
									<v-col offset="8">Diskon</v-col>
									<v-col class="font-weight-bold text-right">{{ discountTotal | toRupiah }}</v-col>
								</v-row>
								<v-row class="mt-n3">
									<v-col offset="8">Total Harga</v-col>
									<v-col class="font-weight-bold text-right">{{ grandTotal - discountTotal | toRupiah }}</v-col>
								</v-row>
								<v-row class="mt-n3">
									<v-col offset="8">Potongan Harga</v-col>
									<v-col class="font-weight-bold text-right">{{ detailSR.sr_rebate_value | toRupiah }}</v-col>
								</v-row>
								<v-row class="mt-n3">
									<v-col offset="8">Total Bayar</v-col>
									<v-col class="font-weight-bold text-right">{{ (grandTotal - discountTotal - detailSR.sr_rebate_value) | toRupiah }}</v-col>
								</v-row>
							</template>
						</v-data-table>
					</v-card>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hideDialog">Tutup</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data () {
		return {
			singleSelect: false,
			selected: [],
			headersProduct: [
			{ text: 'Nama Produk', value: 'sr_detail_product_name', sortable: false },
			{ text: 'Jumlah', value: 'sr_detail_quantity', sortable: false, align: 'center' },
			{ text: 'Harga', value: 'sr_detail_product_price', sortable: false, align: 'end' },
			{ text: 'Total Harga(Rp)', value: 'total_price', align: 'end', sortable: false},
			{ text: 'Serial', value: 'sr_detail_serial_string', sortable: false},
			],
		}
	},
	computed:{
		...mapState('sr', ['detailSR']),

		grandTotal(){
			let total = 0
			if (this.detailSR.sr_detail) {
				this.detailSR.sr_detail.forEach( (el) => {
					total += el.sr_detail_product_price * el.sr_detail_quantity
				});
			}
			return total
		},
		discountTotal() {
			return this.detailSR.sr_discount_percent * this.grandTotal / 100
		},

	},
	props: {
		dialog: Boolean
	},
	methods :{
		hideDialog(){
			this.$emit('hideDialog')
		},
	}
};
</script>
